var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.10449C10.6868 2.10449 9.38642 2.36315 8.17317 2.8657C6.95991 3.36824 5.85752 4.10484 4.92893 5.03342C3.05357 6.90879 2 9.45233 2 12.1045C2 14.7567 3.05357 17.3002 4.92893 19.1756C5.85752 20.1041 6.95991 20.8407 8.17317 21.3433C9.38642 21.8458 10.6868 22.1045 12 22.1045C14.6522 22.1045 17.1957 21.0509 19.0711 19.1756C20.9464 17.3002 22 14.7567 22 12.1045C22 10.7913 21.7413 9.49091 21.2388 8.27766C20.7362 7.0644 19.9997 5.96201 19.0711 5.03342C18.1425 4.10484 17.0401 3.36824 15.8268 2.8657C14.6136 2.36315 13.3132 2.10449 12 2.10449ZM16.2 16.3045L11 13.1045V7.10449H12.5V12.3045L17 15.0045L16.2 16.3045Z",
    fill: "#79AC78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.35ea7a0adf644537b143f0944cfe5671.svg";
export { ForwardRef as ReactComponent };